import { useMemo } from 'react';
import { useCurrentUser } from '../api/endpoints/useCurrentUser';
import { useClientId } from './useClientId';

export function useEntityFormAdditionalContext() {
  const clientId = useClientId();
  const { data: currentUserResponse, isLoading } = useCurrentUser(clientId);

  const additionalContext = useMemo(() => {
    const userData = currentUserResponse?.data?.entityData;

    if (!userData) {
      return {};
    }

    return {
      _currentUser: {
        ...userData,
        localeSettings: userData.localeSettings || {},
      },
      // Backend form schemas reference `=_externals.emailId` (e.g. the export
      // form's "sent to this email id" line) — expose the logged-in user's
      // email at the top level for those expressions.
      emailId: userData.profileInformation?.emailAddress,
    };
  }, [currentUserResponse]);

  return { additionalContext, isLoading };
}
